import React, { FC, useMemo } from "react";
import { v5 as uuidv5 } from "uuid";
import { DEFAULT_UID_NAMESPACE } from "../../../helpers";
import { ABCSectionItem } from "./ABCSectionItem";
import { IABCSection } from "./ABCTool.interface";

export interface IABCSectionProps extends IABCSection {
  createRef?: (element: HTMLElement, id: string) => void;
}

const ABCSection: FC<IABCSectionProps> = ({ id, title, items, createRef }) => {
  const itemsWithIDs = useMemo(() => {
    return (
      items?.map((item, index) => {
        return {
          ...item,
          itemKey: uuidv5(String(item.text) + index, DEFAULT_UID_NAMESPACE),
        };
      }) ?? []
    );
  }, [items]);

  return (
    <section
      className="abc-list"
      ref={(element) => createRef?.(element, id)}
      data-testid="abc-navSection-component"
      id={id}
    >
      <h2 className="abc-list__heading" id="abc-a">
        {title}
      </h2>
      <ul className="abc-list__ul">
        {itemsWithIDs.map(({ itemKey, ...rest }) => (
          <ABCSectionItem key={itemKey} {...rest} />
        ))}
      </ul>
    </section>
  );
};

export default ABCSection;
